import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createRef, useEffect } from 'react';
import { Header } from 'shared/components/Header';
import { clickOpenModal } from 'shared/components/tracking';
import { useApplicationContext } from 'shared/utils/applicationContext';

interface IHeaderContainerProps {
  onChangeModalVisible: VoidFunction;
}

export const HeaderContainer: React.FC<IHeaderContainerProps> = ({ onChangeModalVisible }) => {
  const device = useDeviceType();

  const {
    custom: { userId },
  } = useApplicationContext();

  const menuRef = createRef<HTMLDivElement>();

  const { state: isOpenMenu, toggle: toggleIsOpenMenu } = useToggleState(false);

  useEffect(() => {
    return clearAllBodyScrollLocks();
  }, []);

  useEffect(() => {
    if (menuRef.current) {
      const bodyScrollAction = isOpenMenu ? disableBodyScroll : enableBodyScroll;
      bodyScrollAction(menuRef.current);
    }
  }, [isOpenMenu, menuRef]);

  const handleOpenModal = () => {
    onChangeModalVisible();
    clickOpenModal('rentFlat', userId);
  };

  return (
    <Header
      onChangeModalVisible={handleOpenModal}
      isOpen={isOpenMenu}
      device={device}
      onOpenMenu={toggleIsOpenMenu}
      menuRef={menuRef}
    />
  );
};
